var app = angular.module('inoApp');

app.factory('contentVersionningInterceptor', ['$templateCache', 'config', function ($templateCache, config) {
    var interceptor = {
        request: function (request) {
            // Just add the version id to the supported URL (meaning not from the template cache, the API, IdentityServer URLs, etc.)
            if (!$templateCache.get(request.url) && isSupportedUrl(request.url)) {
                // Append the app version as a querystring parameters to all other calls.
                // This is to deal with potential browser cache issues between versions of the application.
                request.url = buildUrl(request.url, 'vid', encodeURIComponent(config.appVersion));
            }

            return request;
        }
    };

    return interceptor;

    function isSupportedUrl(url) {
        var isSupported = true;
        if (config.servicesUrl && config.servicesUrl.api && config.servicesUrl.identity) {
            if (isUrlSameAsApiUrl(config.servicesUrl.identity.userInfoEndpoint, url))
                isSupported = false;
            else if (isUrlSameAsApiUrl(config.servicesUrl.identity.refreshTokenUrl, url))
                isSupported = false;
            else if (config.servicesUrl.api.apiBasePaths) {
                for (var pathIndex in config.servicesUrl.api.apiBasePaths) {
                    if (isUrlSameAsApiUrl(config.servicesUrl.api.apiBasePaths[pathIndex], url)) {
                        isSupported = false;
                        break;
                    }
                }
                
            }
        }

        return isSupported;
    }

    function isUrlSameAsApiUrl(apiUrl, url){
        if (apiUrl == null || typeof (apiUrl) === "undefined" || (apiUrl !== url && url.indexOf(apiUrl) !== 0))
            return false;
        return true;
    }


    function buildUrl(baseUrl, key, value) {
        var separator = (baseUrl.indexOf('?') > -1) ? '&' : '?';
        return baseUrl + separator + key + '=' + value;
    }
}]);

app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('contentVersionningInterceptor');
}]);